import { useNewUserAccessRights } from '@app/hooks';

export const useClientsAccessRights = () => {
  const {
    userAccessRights: {
      Clients: {
        IsExport,
        IsCreate,
        IsEdit,
        IsDelete,
        IsShowContacts,
        IsCommunicate,
      },
    },
  } = useNewUserAccessRights();

  return {
    hasUserRightToExport: IsExport,
    hasUserRightToCreate: IsCreate,
    hasUserRightToEdit: IsEdit,
    hasUserRightToCommunicate: IsCommunicate,
    hasUserRightToDelete: IsDelete,
    hasUserRightToShowContacts: IsShowContacts,
  };
};
